import { DOCUMENT_ACTION } from "../redux/action";
import { Toaster } from "./common";
import {
  isNotFoundApiResponse,
  markDocumentDetailMissing,
} from "./documentApiCapability";

export const DOCUMENT_UNAVAILABLE_MESSAGE =
  "This document is no longer available";

export { isNotFoundApiResponse };

export function enrichNotificationFromDocumentDetail(notification, detailRes) {
  if (detailRes?.status !== 200 || !detailRes?.data?.data) {
    return notification;
  }

  const data = detailRes.data.data;
  return {
    ...notification,
    document_category:
      data.document_category ||
      data.folder_category ||
      data.category ||
      notification.document_category,
  };
}

/**
 * Client document notifications: confirm the file still exists before routing.
 * A stale notification should surface a message, not a silent failed folder search.
 */
export async function resolveClientDocumentNotification(notification) {
  const notificationType = String(
    notification?.notification_type || "",
  ).toLowerCase();
  const itemId = notification?.notification_item_id;

  if (notificationType !== "document" || !itemId) {
    return { ok: true, enriched: notification };
  }

  const detailRes = await DOCUMENT_ACTION.getDocumentDetails(itemId);
  if (isNotFoundApiResponse(detailRes)) {
    markDocumentDetailMissing(itemId);
    return { ok: false, notFound: true };
  }

  return {
    ok: true,
    enriched: enrichNotificationFromDocumentDetail(notification, detailRes),
  };
}

export function showDocumentUnavailableMessage() {
  Toaster.warning(DOCUMENT_UNAVAILABLE_MESSAGE);
}
